module.exports = __webpack_public_path__ + "static/salesforce-a70291b8a096b320e8e39e75864bd1e6.svg";